module.exports = __webpack_public_path__ + "static/media/81AtD3TZ2rL._AC_UX569_.ce0f9989.jpg";